import React, { FC, useRef } from 'react'
import './restricted-purchases.css'

// COMPONENTS
import * as Icons from '@icons'
import Button from '@components/atoms/button'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> { }

const restrictedCategories = ['gas stations', 'illegal substances', 'money transfer apps', 'gambling funds', 'adult sites', 'weapons']
const restrictedCategoryIcons: Record<string, keyof typeof Icons> = {
    "gas stations": "Gas",
    "illegal substances": "Medicine",
    "money transfer apps": "MoneyTransfer",
    "gambling funds": "Gambling",
    "adult sites": "AdultSites",
    "weapons": "Weapons",
}

const RestrictedPurchases: FC<Props> = (props) => {
    const { className: classProp, ...divProps } = props
    const className = flatten('restricted-purchase-notice', classProp)

    const ref = useRef<HTMLDialogElement>(null)
    function openFeeInfo() { if (ref.current) ref.current.showModal() }
    function closeFeeInfo() { if (ref.current) ref.current.close() }

    return (
        <div className={className} {...divProps}>
            <p className="text-body-2 text-gray-500" style={{ fontWeight: 'bold' }}>Not allowed with Splitcard</p>
            <Icons.Info onClick={openFeeInfo} type='filled' height="1rem" width="1rem" style={{ color: 'var(--splitcard-blue-500)', cursor: 'pointer' }} />
            <dialog ref={ref}>
                <div>
                    <div className="flex flex-col items-stretch" style={{ maxWidth: 'calc(var(--max-content-width, 610px) - 8rem)', textAlign: 'center', margin: '1rem', background: 'var(--splitcard-white)', gap: '1rem', padding: '1.3125rem', borderRadius: 'var(--border-radius)', overflowY: 'auto' }}>
                        <div className="bubble-md flex items-center justify-center" style={{ alignSelf: 'center' }}>
                            <Icons.Shield tint="var(--splitcard-blue-500)" width="5em" height="5em" type='filled' />
                        </div>
                        <h1>Spending Restrictions</h1>
                        <p className='text-body text-gray-500'>To keep our platform safe, purchases are not allowed in the following categories:</p>
                        {restrictedCategories.map((category, index) => (
                            <RestrictedCategoryCell key={`${category}-${index}`} category={category} />
                        ))}
                        <div className="flex flex-col items-stretch gap-2.5">
                            <Button theme="primary" formMethod="dialog" onClick={closeFeeInfo}>Got it!</Button>
                        </div>
                    </div>
                </div>
            </dialog>
        </div>
    )
}

const RestrictedCategoryCell: FC<React.HTMLAttributes<HTMLDivElement> & { category: string }> = (props) => {
    const { category, ...divProps } = props
    const Icon = Icons[restrictedCategoryIcons[category]]

    return (
        <div className='category' {...divProps}>
            <Icon tint="var(--splitcard-gray-500)" width="1.5em" height="1.5em" />
            <p>{category}</p>
        </div>
    )
}

export default RestrictedPurchases